module.exports = __webpack_public_path__ + "img/dino_28l.cc7baa8c.png";